import { useContext } from 'react'
import DictionaryContext, {
  DictionaryContextInterface,
} from '../../contexts/dictionary/DictionaryContext'

const useDictionary = (): DictionaryContextInterface =>
  useContext(DictionaryContext)

export default useDictionary
